// extracted by mini-css-extract-plugin
export var errorsContainer = "_qp-1";
export var link = "_qp-0";